import type { SendCodeResp, VerifyCodeResp } from "@/types/passwordlessAuth.ts";
import type { WhatsappStartResp } from "@/types/whatsappSignIn.ts";

const SOMETHING_WENT_WRONG = "Something went wrong. Please try again.";

/** What to show after sending a code, or "" when there is nothing to say. */
export const sendFailureMessage = (failed: boolean, resp: SendCodeResp | undefined): string => {
  if (failed) return SOMETHING_WENT_WRONG;
  return resp?.status === "error" ? resp.message : "";
};

/** What to show after starting a WhatsApp sign-in, or "" when there is nothing to say. */
export const startFailureMessage = (
  failed: boolean,
  resp: WhatsappStartResp | undefined,
): string => {
  if (failed) return SOMETHING_WENT_WRONG;
  return resp?.status === "error" ? resp.message : "";
};

/** What to show after checking a code, or "" when there is nothing to say. */
export const verifyFailureMessage = (failed: boolean, resp: VerifyCodeResp | undefined): string => {
  if (failed) return SOMETHING_WENT_WRONG;
  switch (resp?.status) {
    case "invalid-code":
      return "Invalid code. Please try again.";
    case "error":
      return resp.message;
    default:
      return "";
  }
};
